import { csrfFetch } from './helpers.js';

export async function pusherChannelCustomHandler(
  pusher,
  { socketId, channelName },
  callback
) {
  console.log(
    `[PUSHER CUSTOM] 🔄 Authorizing pusher channel '${channelName}' and socketId: ${socketId}`
  );

  const channel = pusher.channel(channelName);

  if (!channel.__eventsBinded) {
    channel.bind('pusher:subscription_succeeded', () => {
      if (channel.__authErrorRetryCount) {
        document.dispatchEvent(
          new CustomEvent('pusher-retry-success', {
            detail: { channelName, retryCount: channel.__authErrorRetryCount },
          })
        );
      }
    });
    channel.__eventsBinded = true;
  }

  try {
    const auth = await getAuthToken({
      socket_id: socketId,
      channel_name: channelName,
    });
    console.log(
      `[PUSHER CUSTOM] 🟢 Successful channel authorization for ${channelName} and ${socketId}`
    );
    callback(null, auth);
  } catch (originalError) {
    const response = originalError.response;
    if (!response) throw originalError;

    const error = new Error(
      `[PUSHER CUSTOM] Failed fetching auth token from server: ${response.status} ${response.statusText} for ${channelName} and ${socketId}`
    );

    error.data = {
      responseStatus: response.status,
      responseStatusText: response.statusText,
      channelName,
      socketId,
      pusherConnectionStatus: pusher.connection.state,
      pusherConnectionTimeline: pusher.connection.timeline,
      navigatorOnLine: navigator.onLine,
    };

    retryChannelSubscription({
      channel,
      responseStatus: response.status,
    });

    console.error(error);

    callback(error, null);
  }
}

document.addEventListener('pusher-retry-success', ({ detail }) => {
  console.log(
    `🟢🟢🟢🟢 Subscription succeeded after ${detail.retryCount} retries for: ${detail.channelName}`
  );
});

function retryChannelSubscription({ channel, responseStatus }) {
  channel.__authErrorRetryCount ??= 0;

  const maxRetries = {
    401: 1,
    403: 3,
    0: 10, // Webkit no network
  };

  // Default to 1 retry for other status codes eg. 500
  const retryMax = maxRetries[responseStatus] || 5;

  if (channel.__authErrorRetryCount >= retryMax) {
    console.error(
      `[PUSHER CUSTOM] Aborting channel '${channel.name}' subscription retry as it failed more than ${retryMax} times.`
    );
    return;
  }

  const jitter = Math.floor(Math.random() * 3000);
  const waitTime = 1000 + jitter;

  clearTimeout(channel.__retryTimeout);
  console.log(
    '[PUSHER CUSTOM] 🕛 Retrying channel subscription in',
    waitTime,
    'ms'
  );
  channel.__retryTimeout = setTimeout(() => {
    channel.__authErrorRetryCount += 1;
    channel.subscribe();
  }, waitTime);
}

async function getAuthToken(data) {
  const response = await csrfFetch('/pusher/auth', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  return await response.json();
}
